/**
 * Data Recovery Utility Functions
 *
 * Handles detection of leads that need data recovery
 * (legacy leads created before Dec 26, 2025 with placeholder phone)
 */

// Data recovery cutoff date - leads created before this with placeholder phone need recovery
export const DATA_RECOVERY_CUTOFF_DATE = new Date('2025-12-26T00:00:00Z');
export const PLACEHOLDER_PHONE = '0000000000';

export interface DataRecoveryLead {
  _id: string;
  bride_name: string;
  groom_name?: string;
  contact_email: string;
  contact_phone: string;
  country_code: string;
  referral_sources: string[];
  plan_type: 'weekday' | 'weekend';
  guest_count: number;
  event_date?: string;
  created_at?: string;
  converted?: boolean;
}

/**
 * Check if a lead needs data recovery
 * Criteria: phone is placeholder AND created before cutoff date AND converted
 */
export function needsRecovery(lead: DataRecoveryLead | null): boolean {
  if (!lead) return false;
  if (lead.contact_phone !== PLACEHOLDER_PHONE) return false;
  if (!lead.converted) return false;
  if (!lead.created_at) return false;

  const createdAt = new Date(lead.created_at);
  return createdAt < DATA_RECOVERY_CUTOFF_DATE;
}
